/**
 * 객체 타입에 따른 컨트롤 색상 결정
 * group→보라, table→초록, wordWrap→초록, TextBoxGroup(wordWrap)→초록, 기본→파란
 */
export const getControlColor = (obj) => {
  if (!obj) return '#3b82f6';
  if (obj._isFrame) return '#06b6d4'; // 프레임 → 청록색
  const isGroup = obj.type === 'group' && !obj._isTextBoxGroup && !obj._isTableGroup;
  const isTableGroup = obj.type === 'group' && obj._isTableGroup;
  const isWordWrap = obj.type === 'textbox' && obj.wordWrap === true;
  const isTextBoxGroup = obj.type === 'group' && obj._isTextBoxGroup;
  const textBoxGroupWordWrap = isTextBoxGroup && obj.getObjects?.().find(c => c.type === 'textbox' || c.type === 'i-text')?.wordWrap === true;
  return isGroup ? '#8b5cf6' : isTableGroup ? '#059669' : (isWordWrap || textBoxGroupWordWrap) ? '#22c55e' : '#3b82f6';
};

/**
 * 객체에 커스텀 선택 스타일 적용 (원형 핸들, 타입별 색상)
 */
export const applySelectionStyle = (obj) => {
  const color = getControlColor(obj);
  obj.set({
    cornerStyle: 'circle',
    cornerColor: color,
    cornerStrokeColor: '#ffffff',
    cornerSize: 10,
    transparentCorners: false,
    borderColor: color,
  });
};
